import { ForbiddenError } from '@lucidlink/sdk/fetcher';
import { CurrentMemberKeyFactory } from '#query-hooks';
export const refetchCurrentMember = async ({ error, params: { queryClient, workspaceId }, }) => {
    if (!(error instanceof ForbiddenError)) {
        // eslint-disable-next-line no-console -- warning if used with incorrect type
        return console.error(`Handler used with incorrect error type. Required error ${ForbiddenError.name}`);
    }
    await queryClient.refetchQueries({
        queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
        exact: true,
    });
};
